export default {
  createNewStandardDatabase: 'create a new standard database',
  goToDrawingLists: 'go to the drawing lists',
  goToClassManagement: 'go to the class management',
  goToEntityManagement: 'go to the entity management',
  upgrade: 'upgrade',
  thumbnail: 'thumbnail',
  upgradeStandard: 'upgrade standard',
  thumbnailsCanOnlyBeInJpgPng: 'thumbnails can only be in jpg, png format',
  theSizeUploadAvatarOnlyHalfMb: 'the size of uploaded avatar image cannot exceed 0.5Mb',
  confirmDeleteSelectedStandard: 'are you sure to delete the selected standard',
  createStandard: 'create a standard',
  editTheStandard: 'edit the standard',
  pleaseEnterTheVersion: 'please enter the version',
  working: 'working',
  released: 'released',
  standrad: 'standrad',
  pleaseEnterStandradNameOrCode: 'please enter standard name or code',
  standardCode: 'Standard Code',
  standardName: 'Standard Name',
  CreateUser: 'Create User',
  Class: 'Class',
  TheRecommendedSizeIs220Pixels: 'The recommended size is 220*170 pixels.',
  TheSizeOfTheUploadedImageCannotExceed5MB: 'The size of the uploaded image cannot exceed 5MB.',
  publish: 'Publish',
  unpublished: 'Unpublished',
  storeSettings: 'Store Settings',
  attributeGrouping: 'Attribute Grouping',
  attribute: 'Attribute',
  grouping: 'Grouping',
  selectTheGroup: 'Select the Group',
  readAndQritePermissions: 'Read and Write Permissions',
  APIInputField: 'API Input Field',
  queryDataIsNotDisplayed: 'Query data is not displayed',
  whetherItIisAtypeOrNot: 'Whether it is a type or not',
  pleaseSelectABusinessType: 'Please select a business type',
  whetherItIsMasterDataOrNot: 'Whether it is master data or not',
  pleaseSelectMasterDataType: 'Please select a master data type',
  topic: 'Topic',
  label: 'Label',
  extendedProperties: 'Extended Properties',
  extendPropertyValue: 'Extend the property value',
  pleaseSelectGroupYouWantToEdit: 'Please select the group you want to edit',
  entitiesOrDocumentsCannotBeEdited: 'Entities or documents cannot be edited',
  groupNameCannotBeUngrouped: 'The group name cannot be "Ungrouped"',
  selectAttributeGroupYouWantToDelete: 'Please select the attribute group you want to delete',
  entitiesDocumentsCannotBeDeleted: 'Entities or documents cannot be deleted',
  deleteAttributeGrouping: 'Are you sure you want to delete the attribute grouping?',
  cannotBeGrouped: 'Objects or documents cannot be grouped',
  tickData: 'TicK Data',
  setGroupSuccessful: 'Set Group Successful',
  removeGroupSuccessful: 'Remove Group Successful',
  goToDatasetManagement: 'Go to Dataset Management',
}
